import { PaymentFees } from 'src/types/payment';
import {
  PAYMENT_METHODS,
  PAYMENT_METHOD_LABELS,
  PAYMENT_PROVIDER,
} from '../constants';

export const calculateTotalDue = (
  selectedPaymentMethod?: PAYMENT_METHODS,
  paymentFees?: PaymentFees,
  isGeneric?: boolean
): number => {
  if (isGeneric && paymentFees?.summary) {
    return paymentFees.summary.total || 0;
  }
  switch (selectedPaymentMethod) {
    case PAYMENT_METHODS.ACH_DIRECT_DEBIT:
      return paymentFees?.achTotal || 0;
    case PAYMENT_METHODS.CREDIT_OR_DEBIT__CARD:
      return paymentFees?.ccTotal || 0;
    case PAYMENT_METHODS.CHECK:
      return paymentFees?.checkTotal || 0;
    default:
      return 0;
  }
};

export const calculateProcessingFee = (
  selectedPaymentMethod?: PAYMENT_METHODS,
  paymentFees?: PaymentFees,
  isGeneric?: boolean
): number => {
  if (isGeneric) {
    return 0;
  }
  switch (selectedPaymentMethod) {
    case PAYMENT_METHODS.ACH_DIRECT_DEBIT:
      return paymentFees?.achFee || 0;
    case PAYMENT_METHODS.CREDIT_OR_DEBIT__CARD:
      return paymentFees?.ccFee || 0;
    case PAYMENT_METHODS.CHECK:
      return paymentFees?.checkFee || 0;
    default:
      return 0;
  }
};

export const getProcessingFeeLabel = (
  selectedPaymentMethod?: PAYMENT_METHODS
) => {
  switch (selectedPaymentMethod) {
    case PAYMENT_METHODS.ACH_DIRECT_DEBIT:
      return PAYMENT_METHOD_LABELS.ACH_DIRECT_DEBIT;
    case PAYMENT_METHODS.CREDIT_OR_DEBIT__CARD:
      return PAYMENT_METHOD_LABELS.CREDIT_OR_DEBIT__CARD;
    case PAYMENT_METHODS.CHECK:
      return PAYMENT_METHOD_LABELS.CHECK;
    default:
      return 'Processor Fee';
  }
};

export const isGeneric = (provider?: PAYMENT_PROVIDER) => {
  return (
    provider === PAYMENT_PROVIDER.GENERIC ||
    provider === PAYMENT_PROVIDER.CARD_CONNECT ||
    provider === PAYMENT_PROVIDER.HEARTLAND ||
    provider === PAYMENT_PROVIDER.XPRESS_BILL_PAY ||
    provider === PAYMENT_PROVIDER.INTELLIPAY ||
    provider === PAYMENT_PROVIDER.CERTIFIED_PAYMENTS
  );
};

export const resolveSuccessUrlSuffix = () => {
  const isTaxPayment = window.location.href.endsWith('/tax-payment');
  const isApplyPayment = window.location.href.endsWith('/apply-payment');
  const isRenewPayment = window.location.href.endsWith('/renew-payment');

  if (isTaxPayment) {
    return '/tax-success';
  } else if (isApplyPayment) {
    return '/apply-success';
  } else if (isRenewPayment) {
    return '/renew-success';
  }
  return '/payment-success';
};
